"use client";

import { useEffect } from "react";

import UnknownError from "@/app/errors/unknownError";

/**
 * Global error boundary for root layout errors.
 * This catches errors that occur in the root layout itself.
 *
 * IMPORTANT: This component MUST:
 * 1. Be a client component ("use client")
 * 2. Include its own <html> and <body> tags (replaces root layout)
 * 3. NOT import any Server Components or server-only code
 *
 * Note: This only activates in production. In development,
 * you'll see the Next.js error overlay instead.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <html>
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        {/* eslint-disable-next-line @next/next/no-page-custom-font -- global-error replaces the root layout, so Gabarito (the design-system primary font) must be loaded here too. */}
        <link
          href="https://fonts.googleapis.com/css2?family=Gabarito:wght@400;500;600;700;900&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <UnknownError error={error} />
      </body>
    </html>
  );
}
